// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ftLqr","left":"styles_left__2R6LE","right":"styles_right__U_JMg","alert":"styles_alert__25kOk"};